import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';

import React from 'react';
import { useAppSelector } from '../../../store';

export default function ModalDialog(props: any) {
    const { words } = useAppSelector(state => state.localization);

    const handleClose = () => {
        props.setOpen(false);
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-06"
            open={props.open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            onClose={handleClose}>
            <Fade in={props.open}>
                <div className="modal-content">

                    {
                        props.handleUpdateAction &&
                        <svg className="icon" width="102" height="102" viewBox="0 0 102 102" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M51 85H89.25" stroke="#00A3FF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M70.125 14.875C71.8158 13.1842 74.1089 12.2344 76.5 12.2344C77.6839 12.2344 78.8563 12.4676 79.9501 12.9206C81.044 13.3737 82.0378 14.0378 82.875 14.875C83.7122 15.7122 84.3763 16.706 84.8293 17.7999C85.2824 18.8937 85.5156 20.066 85.5156 21.25C85.5156 22.4339 85.2824 23.6063 84.8293 24.7001C84.3763 25.7939 83.7122 26.7878 82.875 27.625L29.75 80.75L12.75 85L17 68L70.125 14.875Z" stroke="#00A3FF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    }

                    {
                        props.deleteActions &&
                        <svg className="icon" width="70" height="70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 6H5H21" stroke="#00A3FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path
                                d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                                stroke="#00A3FF"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path d="M10 11V17" stroke="#00A3FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 11V17" stroke="#00A3FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    }
                    <p className="title" id="transition-modal-description">
                        {props.message}
                    </p>
                    <div className="button-wrap">
                        <button className="button-01" type="button" onClick={handleClose}>
                            {words && words['WEB.cancel']}
                        </button>
                        {
                            props.deleteActions &&
                            <button className="button-02" onClick={() => props.deleteActions()} type="button">
                                {words && words['WEB.delete']}
                            </button>
                        }
                        {
                            props.handleUpdateAction &&
                            <button className="button-02" onClick={() => props.handleUpdateAction()} type="button">
                                {words && words['WEB.UPDATE']}
                            </button>
                        }
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}
